// src/utils/isAllowedPath.ts

// 中文：判斷路徑是否允許交給 legacy app
// English: Check if path is allowed to be handled by legacy app
export function isAllowedPathname(pathname: string): boolean {
    const p = pathname.startsWith('/') ? pathname : '/' + pathname;

    if (p.startsWith('/_next')) return true;
    if (p === '/favicon.ico' || p === '/robots.txt' || p === '/sitemap.xml') return true;
    if (p === '/') return true;

    const allowedPrefixes = [
        '/applications',
        '/Applications',
        '/products',
        '/About',
        '/SalesResources',
        '/browse',
        '/events',
        // Internal QA page for the HubSpot -> MCAE form migration (noindex, unlinked)
        '/mcae-form-test',
        // Search feedback lab (semantic/TASKS.md X2): off in prod, noindex, unlinked
        '/search-lab',
        '/no_results',
        '/404_error',
        '/500_error',
        '/obb',
        '/tools',
        '/sales',
        '/wp-content',
        '/Lists',
        '/53142',
        '/en.html',
        '/jp.html',
        '/ca.html',
        '/ta.html',
        '/de.html',
        '/en/',
        '/jp/',
        '/ca/',
        '/ta/',
        '/de/',
    ];

    return allowedPrefixes.some((prefix) => p === prefix || p.startsWith(prefix));
}
